import { Maybe } from '@/utils/types'
import { ContentInteraction } from '../useContentInteraction'

type Surface = 'brand_landing'
type ItemType = 'ContentSeries' | 'ContentMovie' | 'ContentSpecial'

/**
 * Interaction builder for franchise projects in the collection/franchise tab
 * Used for tracking user interactions with related franchise content
 */
export class FranchiseTabItemInteraction extends ContentInteraction<Surface> {
  constructor(item: { id: string; __typename: Maybe<ItemType>; attribution: unknown }) {
    super(item)
  }
}
